import { render } from "./ExpeditionsComponent.vue?vue&type=template&id=6a3ef3da"
import script from "./ExpeditionsComponent.vue?vue&type=script&lang=js"
export * from "./ExpeditionsComponent.vue?vue&type=script&lang=js"

import "./ExpeditionsComponent.vue?vue&type=style&index=0&id=6a3ef3da&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__